import React from 'react';
import { ExternalLink, Logo, SectionWrapper, SocialBar, SocialIcon, FlexSpread, FlexStart, FlexCenter, BottomIconLink, BottomIcon, SectionWrapperWithBorder, Copyright, RegularLink, BottomFooterLink } from './FooterBottom.styles';
import DataPresenter from '../../data-presenter';

var FooterBottom = function FooterBottom(_a) {
  var logo = _a.logo,
      socialMediaLinks = _a.socialMediaLinks,
      bottomIcons = _a.bottomIcons,
      copyright = _a.copyright,
      homeUrl = _a.homeUrl,
      linkComponent = _a.linkComponent,
      isLoading = _a.isLoading,
      sitemapUrl = _a.sitemapUrl,
      sitemapLabel = _a.sitemapLabel;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SectionWrapper, null, /*#__PURE__*/React.createElement(FlexSpread, null, /*#__PURE__*/React.createElement(RegularLink, {
    as: linkComponent,
    href: isLoading || !homeUrl ? '#' : homeUrl
  }, isLoading || !(logo === null || logo === void 0 ? void 0 : logo.url) ? /*#__PURE__*/React.createElement(DataPresenter, {
    nodata: true,
    loading: isLoading,
    width: 8,
    height: 4
  }) : /*#__PURE__*/React.createElement(Logo, {
    style: {
      backgroundImage: "url('" + logo.url + "')"
    },
    "data-test": 'footer-logo',
    "data-test-image": logo.url,
    role: 'img',
    "aria-label": logo.alternativeText || ''
  })), /*#__PURE__*/React.createElement(SocialBar, null, isLoading || !socialMediaLinks ? [1, 2, 3, 4].map(function (soc) {
    return /*#__PURE__*/React.createElement(DataPresenter, {
      key: soc,
      nodata: true,
      loading: isLoading,
      width: 3.2,
      height: 3.2
    });
  }) : socialMediaLinks.map(function (link) {
    return /*#__PURE__*/React.createElement(ExternalLink, {
      as: linkComponent,
      key: link.id,
      href: link.link,
      dataTest: 'footer-social-link',
      "data-test": 'footer-social-link'
    }, /*#__PURE__*/React.createElement(SocialIcon, {
      style: {
        backgroundImage: "url('" + link.icon.url + "')"
      },
      role: 'img',
      "aria-label": link.icon.alternativeText || ''
    }));
  })))), /*#__PURE__*/React.createElement(SectionWrapperWithBorder, null, /*#__PURE__*/React.createElement(FlexCenter, null, isLoading || !bottomIcons ? [1, 2, 3, 4].map(function (icon) {
    return /*#__PURE__*/React.createElement(DataPresenter, {
      key: icon,
      nodata: true,
      loading: isLoading,
      width: 20,
      height: 4.8
    });
  }) : bottomIcons.map(function (bottomIcon) {
    return /*#__PURE__*/React.createElement(BottomIconLink, {
      as: linkComponent,
      key: bottomIcon.id,
      href: bottomIcon.link
    }, /*#__PURE__*/React.createElement(BottomIcon, {
      style: {
        backgroundImage: "url('" + bottomIcon.icon.url + "')"
      },
      role: 'img',
      "aria-label": bottomIcon.icon.alternativeText || ''
    }));
  }))), /*#__PURE__*/React.createElement(SectionWrapper, null, /*#__PURE__*/React.createElement(FlexStart, null, isLoading || !copyright ? /*#__PURE__*/React.createElement(DataPresenter, {
    nodata: true,
    loading: isLoading,
    width: 12,
    height: 2
  }) : /*#__PURE__*/React.createElement(Copyright, {
    "data-test": 'footer-copyright'
  }, copyright), isLoading ? /*#__PURE__*/React.createElement(DataPresenter, {
    nodata: true,
    loading: isLoading,
    width: 6,
    height: 2
  }) : sitemapUrl && /*#__PURE__*/React.createElement(BottomFooterLink, {
    as: linkComponent,
    href: sitemapUrl
  }, sitemapLabel || sitemapUrl))));
};

export default FooterBottom;